// extracted by mini-css-extract-plugin
export default {"multiValueList":"MultivalueField__multiValueList___bykig","coloredField":"MultivalueField__coloredField___DxumX"};